import React, { useState, useRef, useEffect } from 'react';
import { Box, Grid, TextField, Button, Typography } from '@mui/material';
import botLogo from '../../Assets/imgs/Logo-Master.png'
// import Pdfviewer from './Pdfviewer';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from "@mui/material";
import Sidebar from '../../Components/Sidebar';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Container,useTheme,useMediaQuery } from "@mui/material";
import { useSpeechRecognition } from 'react-speech-recognition';
import SpeechRecognition from 'react-speech-recognition';
import TableDisplay from '../../Components/TableDisplay';
import MarkdownMessage, { extractTerraformFiles } from '../../Components/MarkdownMessage';
import { AttachmentChip, DEFAULT_ATTACHMENT_PROMPTS } from '../../Components/Attachment';
import Composer from '../../Components/Composer';
import CodeEditorPane from '../../Components/CodeEditorPane';
import '../../Assets/css/ChatUI.css';
import ModeSelector, { CHAT_MODE_KEY, CHAT_CLOUD_KEY, getModeConfig, readStoredMode, readStoredCloud } from '../../Components/ModeSelector';
import BouncingDotsLoader from '../../Components/BouncingDotsLoader';
import FileDownloads, { stripFileData } from '../../Components/FileDownloads';

const CHAT_HISTORY_KEY = 'chatHistory';
const isAdvisorMode = (mode) => mode === 'review' || mode === 'terraform';
// Modes whose answers are full Markdown (OpManager answers have tables but no attachments)
const isMarkdownMode = (mode) => isAdvisorMode(mode) || mode === 'opm';
const MAX_HISTORY_PER_MODE = 3;
const backendURL = process.env.REACT_APP_TWCHATBOT;

// Escape bot output before injecting our own markup via dangerouslySetInnerHTML
const escapeHtml = (text) =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const ChatPage = () => {
  const [pdfUrl, setPdfUrl] = useState(null); // State for PDF URL
  const chatEndRef = useRef(null);


  const handleClosePdfViewer = () => {
    setPdfUrl(null); // Close the PDF viewer
  };
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedReference, setSelectedReference] = useState(null);
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  // 'rag' = answer from documents, 'review' = suggest enhancements, 'terraform' = generate Terraform
  const [mode, setMode] = useState(() => location.state?.mode || readStoredMode());
  const [cloud, setCloud] = useState(() => location.state?.cloud || readStoredCloud());
  // Attached file for the review / terraform modes: { name, size, data (base64) }
  const [attachment, setAttachment] = useState(null);
  const [attachmentError, setAttachmentError] = useState('');
  // Files shown in the side editor pane (multi-file Terraform answers)
  const [editorFiles, setEditorFiles] = useState(null);
  const activeAttachment = isAdvisorMode(mode) ? attachment : null;
  const [chatHistory, setChatHistory] = useState(() => {
    // A reload kills any in-flight socket, so clear the pending lock and stale loading bubbles
    localStorage.setItem('responsePending', 'false');
    const savedChatHistory = localStorage.getItem(CHAT_HISTORY_KEY);
    const parsed = savedChatHistory ? JSON.parse(savedChatHistory) : [];
    return parsed.filter(chat => !chat.loading);
  });
  const [conversationHistory, setConversationHistory] = useState(() => {
    const savedConversationHistory = localStorage.getItem('conversation_history');
    return savedConversationHistory ? JSON.parse(savedConversationHistory) : [];
  });
  
  const [references, setReferences] = useState(() => {
    const savedReferences = localStorage.getItem('references');
    return savedReferences ? JSON.parse(savedReferences) : [];
  });
  const chatHistoryRef = useRef(null);
  const navigate = useNavigate();
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const [sidebarReferencesClicked, setSidebarReferencesClicked] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [showOtherFile, setShowOtherFile] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedAnotherFile, setSelectedAnotherFile] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [activeRefIndex, setActiveRefIndex] = useState(null);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [currentMessageTime, setCurrentMessageTime] = useState("");
  const [fullname, setFullname]=useState('')
  const [email,setEmail]=useState('')
  // const ws = useRef(null);
  const initialFetchMade = useRef(false); 
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [answer, setAnswer] = useState('');
  // const [question, setQuestion] = useState('');
  // const [currentTime, setCurrentTime] = useState('');
  const [socket, setSocket] = useState(null);


  useEffect(() => {
    // Fetch data from local storage when the component mounts
      const storedData = localStorage.getItem('formData');
      if (storedData) {
        const data = JSON.parse(storedData);
        setEmail(data.email || ''); // Provide default values to avoid undefined
        setFullname(data.fullname || '')
      }
  }, []); 
  useEffect(() => {
    if (chatHistoryRef.current) {
        chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
}, [chatHistory]);

  

  useEffect(() => {
    // Load chat history from localStorage when component mounts
    const savedChatHistory = localStorage.getItem(CHAT_HISTORY_KEY);
    if (savedChatHistory) {
      const parsedHistory = JSON.parse(savedChatHistory);
      if (parsedHistory.length > 0) {
        setChatHistory(parsedHistory);
      }
    }
  }, []);
  useEffect(() => {
    localStorage.setItem('conversation_history', JSON.stringify(conversationHistory));
  }, [conversationHistory]);
  useEffect(() => {
    // Save chat history to localStorage whenever chatHistory changes
    if (chatHistory.length > 0) {
      // Generated files are large: keep only their names
      localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(chatHistory.map(stripFileData)));
    }
  }, [chatHistory]);
  useEffect(() => {
    if (showSidebar) {
      setSidebarReferencesClicked(true);
    } else {
      setSidebarReferencesClicked(false);
      setSelectedAnotherFile(false);
    }
  }, [showSidebar]);

  useEffect(() => {
    if (selectedReference) {
      setSelectedAnotherFile(true);
    }
  }, [selectedReference]);

  useEffect(() => {
    if (!showSidebar) {
      setActiveRefIndex(null);
    }
  }, [showSidebar]);

  const handleReferenceClick = (reference, page_no, index,time,chunk) => {
    
      setSidebarOpen(false);
      setCurrentMessageTime(time);
      setActiveRefIndex(index);
      const selectedRef = references.find(ref => ref.content === reference && ref.page_no === page_no && ref.chunk.trim() === chunk.trim());
      if (selectedRef) {
        setSelectedReference({ reference: selectedRef.content, index, page_no: selectedRef.page_no ,chunk:selectedRef.chunk});
        setSidebarReferencesClicked(true);
        setShowSidebar(true);
        setShowFile(true);
        setSelectedFile(selectedRef.title);
        setFileUrl(selectedRef.title);
        if (selectedRef.filepath !== selectedFile) {
          setShowOtherFile(!showOtherFile);
          setSelectedFile(selectedRef.title);
          setFileUrl(selectedRef.title);
          setShowFile(true);
        }
      }
  };


  useEffect(() => {
    localStorage.setItem(CHAT_MODE_KEY, mode);
  }, [mode]);
  useEffect(() => {
    localStorage.setItem(CHAT_CLOUD_KEY, cloud);
  }, [cloud]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Save references to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('references', JSON.stringify(references));
  }, [references]);
  const handleSendMessage = () => {
    if (localStorage.getItem('responsePending') === 'true') {
      return; // Block sending another message
    }
    if (searchTerm.trim() === '' && !activeAttachment) {
      return; // Exit the function to prevent further execution
    }
    localStorage.setItem('responsePending', 'true');
    SpeechRecognition.stopListening();
    setShowFile(false);
    setSelectedReference(null);
    setSelectedFile(null);
    setShowSidebar(false);
    fetchData();
    setSearchTerm('');
    setAttachment(null);
  };
  const formatCurrentTime = () => {
    const now = new Date();
  
    // Format hours and minutes
    const hours = now.getHours() % 12 || 12;  // Convert to 12-hour format
    const minutes = now.getMinutes();
    const period = now.getHours() >= 12 ? 'PM' : 'AM';
  
    // Format day and month
    const day = now.getDate();
    const month = now.toLocaleString('default', { month: 'short' });  // Short month name like "Nov"
  
    // Combine everything together
    return `${hours}.${minutes < 10 ? `0${minutes}` : minutes} ${period}, ${day} ${month}`;
  };

  const fetchData = async (question, attachmentOverride) => {
    const currentTime = formatCurrentTime();
    const requestMode = mode;
    const requestAttachment = isAdvisorMode(requestMode) ? (attachmentOverride || activeAttachment) : null;
    // A file can be sent on its own; use a sensible default instruction
    question = question || searchTerm.trim() || (requestAttachment ? DEFAULT_ATTACHMENT_PROMPTS[requestMode] : '');
    const lastMessage = chatHistory[chatHistory.length - 1];
    
    const storedData = localStorage.getItem('formData');

    if (storedData) {
      // Parse the stored JSON string into an object
      const data = JSON.parse(storedData);
      setEmail(data.email)
      // Return the email property
    }
   
    if (!searchTerm && !question) {
      return; // Exit the function to prevent further execution
    }
    if (lastMessage && lastMessage.role === "user" && lastMessage.message === (question || searchTerm)) {
      return; // Don't add duplicate message
    }
    const newChatHistory = [
      ...chatHistory,
      { role: "user", message: question || searchTerm, time: currentTime, mode: requestMode, attachmentName: requestAttachment?.name },
      { role: "bot", message: " ", time: currentTime, loading: true, mode: requestMode },
    ];
    setChatHistory(newChatHistory);
   
    try {
      const data1 = JSON.parse(storedData);
      // Only send history from the same mode, e.g. long Terraform answers must not skew document search
      const storedConversationHistory = (JSON.parse(localStorage.getItem('conversation_history')) || [])
        .filter(entry => (entry.mode || 'rag') === requestMode)
        .slice(-MAX_HISTORY_PER_MODE)
        .map(entry => entry.mode ? { [entry.question]: entry.answer } : entry);
      const formData = { 
        input_question: question || searchTerm,
        email:data1.email,
        user_name:data1.fullname,
        conversation_history:storedConversationHistory,
        mode: requestMode,
        cloud: cloud,
        // OpManager mode is checked against the SSO sign-in on the server
        ...(requestMode === 'opm' && { id_token: localStorage.getItem('token') }),
        ...(requestAttachment && { attachment: { name: requestAttachment.name, data: requestAttachment.data } })
       };
       

      const ws = new WebSocket(`${backendURL}/answer_questions/`);
      let answered = false;
      // Replace the loading bubble with an error and release the send lock
      const failPendingResponse = (errorMessage) => {
        if (answered) return;
        answered = true;
        localStorage.setItem('responsePending', 'false');
        setChatHistory(prevChatHistory => {
          const newChatHistory = [...prevChatHistory];
          if (newChatHistory.length && newChatHistory[newChatHistory.length - 1].loading) {
            newChatHistory.pop();
          }
          newChatHistory.push({ role: "bot", message: errorMessage || "An unexpected error occurred while processing your request. Please try again shortly", time: currentTime, loading: false });
          return newChatHistory;
        });
      };
      // Event listener for WebSocket connection opening
      ws.onopen = () => {
   
        // Send JSON payload like a POST request on connection
        const payload = formData;
   
        ws.send(JSON.stringify(payload)); // Send JSON data through WebSocket
      };
   
      // Event listener for receiving messages from the server
      ws.onmessage = (event) => {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (parseError) {
          console.error('Invalid WebSocket message:', event.data);
          return;
        }
        if (data.error) {
          failPendingResponse(data.error);
          ws.close();
          return;
        }
        if (data.message)
          { 
            setMessage(data);
            setAnswer('');
          }
          if (data.responses){
          setMessage('');
          setAnswer(data);
          localStorage.setItem('responsePending', 'false');

          const responses = data.responses;
          answered = true;
          const newReferences = data.references || [];
          let formattedAnswer = responses + "\n";
          setReferences((prevReferences) => [...prevReferences, ...newReferences]);
      
          if (newReferences.length > 0) {
            formattedAnswer += "\nReferences:";
            newReferences.forEach((reference) => {
              formattedAnswer += `${reference.content} (Page: ${reference.page_no} (Page: ${reference.chunk}\n+!@`; // Include page_no here
            });
          }
      
      
          setChatHistory(prevChatHistory => {
            const newChatHistory = [...prevChatHistory];
            newChatHistory.pop(); // Remove the loading dots
            newChatHistory.push({ role: "bot", message: formattedAnswer, time: currentTime, loading: false, mode: data.mode || requestMode, ...(data.files && { files: data.files }) });
            return newChatHistory;
          });
          // Show a generated Terraform project in the editor pane straight away
          if ((data.mode || requestMode) === 'terraform') {
            const files = extractTerraformFiles(formattedAnswer);
            if (files.length > 1) {
              setEditorFiles(files);
              setSidebarOpen(false);
            }
          }
            // Update conversationHistory with the new question and answer
        setConversationHistory((prevConversationHistory) => {
          const updatedConversationHistory = [...prevConversationHistory, { question: question || searchTerm, answer: responses, mode: requestMode }];
          
          // Keep the last few turns of each mode
          while (updatedConversationHistory.length > MAX_HISTORY_PER_MODE * 3) {
            updatedConversationHistory.shift(); // Remove the oldest conversation
          }
      
          // Save to localStorage
          localStorage.setItem('conversation_history', JSON.stringify(updatedConversationHistory));
          return updatedConversationHistory;
        });
        // Final answer received; free the server connection
        ws.close();
        }

      };

    // Event listener for WebSocket errors
    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
      failPendingResponse();
    };

    // Event listener for WebSocket closure (closed before a final answer arrived)
    ws.onclose = () => {
      failPendingResponse();
    };
 
    // Store WebSocket in state
    setSocket(ws);
 
    // Cleanup WebSocket when the component unmounts
    return () => {
      ws.close();
    };

    } catch (error) {
      console.error("Error fetching data:", error);
      setChatHistory(prevChatHistory => {
        const newChatHistory = [...prevChatHistory];
        newChatHistory.pop(); // Remove the loading dots
        localStorage.setItem('responsePending', 'false');
        newChatHistory.push({ role: "bot", message: "An unexpected error occurred while processing your request. Please try again shortly", time: currentTime, loading: false });
        return newChatHistory;
      });
    }
    resetTranscript();
    
      
  };
  
  useEffect(() => {
    if (transcript !== '') {
      setSearchTerm(transcript);
    }
  }, [transcript]);

  useEffect(() => {
    const isFetchDone = localStorage.getItem('initialFetchDone');
    
    if (isInitialRender && location.state && location.state.question && !isFetchDone) {
      const { question } = location.state;
      
      // Check the last message to avoid duplicates
      const lastMessage = chatHistory[chatHistory.length - 1];
      if (lastMessage && lastMessage.role === "user" && lastMessage.message === (question || searchTerm)) {
        return; // Don't add duplicate message
      }
  
      // Fetch data only if it hasn't been fetched already
      fetchData(question, location.state.attachment);
      localStorage.setItem('responsePending', 'true');
      // Mark that the fetch has been done in both ref and localStorage
      initialFetchMade.current = true;
      localStorage.setItem('initialFetchDone', 'true');
      setIsInitialRender(false);
    }
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state, isInitialRender]);
  const storedData = localStorage.getItem('formData');
  const data = storedData ? JSON.parse(storedData) : null;
  const nameParts = (data?.fullname || '').split(' ').filter(Boolean);
  const initials = nameParts.map(part => part[0].toUpperCase()).join('').slice(0, 2) || 'U';
  const theme1 = useTheme();
  const isXsScreen = useMediaQuery(theme1.breakpoints.only('xs'));
  const isSmScreen = useMediaQuery(theme1.breakpoints.only('sm'));
  const isMdScreen = useMediaQuery(theme1.breakpoints.only('md'));
  const editorOpen = Boolean(editorFiles && editorFiles.length);
  const openEditor = (files) => {
    setEditorFiles(files);
    setSidebarOpen(false);
  };

  return (
    <Box sx={{ height: '100vh', overflow: 'hidden', backgroundColor: '#fff' }}>
      {/* Sidebar Toggle Button */}
      {!sidebarOpen && (
        <IconButton
          onClick={() => {
            setSidebarOpen(true);
            setShowFile(false);
            setEditorFiles(null);
          }}
          aria-label="Open menu"
          sx={{ position: 'fixed', top: '72px', left: '16px', zIndex: 1300, backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(21,48,82,0.12)', '&:hover': { backgroundColor: '#f3f6fa' } }}
        >
          <MenuIcon sx={{ color: '#153052' }} />
        </IconButton>
      )}

      {/* Sidebar Component */}
      <Sidebar
        isOpen={sidebarOpen}
        currentPage="chat-page"
        onClose={() => setSidebarOpen(false)}
        sidebarOpen={sidebarOpen}
        sx={{
          width: sidebarOpen ? '20%' : '0',
          transition: 'width 0.3s ease',
          '@media (max-width: 600px)': {
            width: sidebarOpen ? '100%' : '0',
          }
        }}
      />

      {/* Main Chat Area: fills the space between the sidebar and the editor pane */}
      <Box
        sx={{
          position: 'fixed',
          top: '64px',
          bottom: 0,
          left: sidebarOpen ? '20%' : 0,
          right: editorOpen ? '50%' : 0,
          display: 'flex',
          flexDirection: 'column',
          transition: 'left 0.3s ease, right 0.3s ease',
          '@media (max-width: 900px)': { right: 0 },
        }}
      >
        <div className="chat-scroll" ref={chatHistoryRef}>
          <div className="chat-column">
            {/* Spacer to push content to bottom */}
            <Box sx={{ flex: 1 }} />

            {chatHistory.length === 0 && (
              <div className="chat-empty">
                <h2 style={{ color: '#153052', margin: '0 0 6px' }}>How can I help with your migration?</h2>
                <p style={{ margin: 0 }}>{getModeConfig(mode).tooltip}.</p>
              </div>
            )}

            {chatHistory.map((chat, index) => (
              <div key={index} className={`chat-row ${chat.role === 'user' ? 'user' : 'bot'}`}>
                {chat.role === 'user' ? (
                  <>
                    <div className="chat-bubble-user">
                      {chat.message.split("References:")[0]}
                      {chat.attachmentName && (
                        <div className="attachment-line">
                          <AttachmentChip attachment={{ name: `📎 ${chat.attachmentName}` }} />
                        </div>
                      )}
                    </div>
                    <div className="chat-avatar user">{initials}</div>
                  </>
                ) : (
                  <>
                    <div className="chat-avatar bot">
                      <img src={botLogo} alt="Assistant" />
                    </div>
                    <div className="chat-bot-content">
                      {isMarkdownMode(chat.mode) && !chat.loading && (
                        <div className="chat-mode-tag">{getModeConfig(chat.mode).icon}{getModeConfig(chat.mode).label}</div>
                      )}
                      {/* Review / Terraform answers are full Markdown with editor-style code blocks */}
                      {!chat.loading && isMarkdownMode(chat.mode) && <MarkdownMessage content={chat.message} onOpenEditor={openEditor} />}
                      {!chat.loading && <FileDownloads files={chat.files} />}
                      {!isMarkdownMode(chat.mode) && chat.message.split("References:")[0].includes('------') && <TableDisplay content={chat.message.split("References:")[0]} />}
                      {!chat.loading && !isMarkdownMode(chat.mode) && !chat.message.split("References:")[0].includes('------') && (
                        <div
                          className="markdown-message"
                          dangerouslySetInnerHTML={{
                            __html: escapeHtml(chat.message.split("References:")[0])
                              .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold for **text**
                              .replace(/(^|\n)###\s*(.*?)(?=\n|$)/g, '$1<strong>$2</strong>') // Bold only for text after ###
                              .replace(/\n/g, '<br />') // Convert newlines to <br />
                          }}
                        />
                      )}
                      {chat.loading && (
                        <div className="chat-thinking">
                          <BouncingDotsLoader themeMode={'light'} />
                          <span>{message.message || 'Thinking...'}</span>
                        </div>
                      )}
                      {/* References Section */}
                      {!isMarkdownMode(chat.mode) && chat.message.includes("References:") && (
                        <Box display="flex" flexDirection={isXsScreen || isSmScreen ? 'column' : 'row'} flexWrap="wrap" alignItems="center" sx={{ gap: 1, marginTop: '10px' }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#153052', fontFamily: 'Kumbh Sans' }}>
                            References:
                          </Typography>
                          {chat.message
                            .split("References:")[1]
                            .split('\n+!@')
                            .filter(reference => reference.trim() !== '')
                            .map((referenceLine, refIndex) => {
                              const [filepath, page_no, chunk] = referenceLine.split(' (Page: ');
                              const pageNo = page_no ? parseInt(page_no.replace(')', '')) : null;
                              const referenceLabel = filepath.replace(/_/g, ' ');
                              return (
                                <button key={refIndex} id={refIndex} type="button" className="reference-chip" onClick={() => handleReferenceClick(filepath, pageNo, refIndex, chat.time, chunk)}>
                                  {referenceLabel}
                                </button>
                              );
                            })}
                        </Box>
                      )}
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Message composer */}
        <div className="composer-dock" style={{ position: 'static', width: '100%' }}>
          <div className="composer-dock-inner">
            <ModeSelector mode={mode} onModeChange={setMode} cloud={cloud} onCloudChange={setCloud} />
            {attachmentError && (
              <Typography sx={{ fontFamily: 'Kumbh Sans', fontSize: '12px', color: '#d32f2f', textAlign: 'center' }}>{attachmentError}</Typography>
            )}
            <Composer
              value={searchTerm}
              onChange={handleSearch}
              onSend={handleSendMessage}
              placeholder={getModeConfig(mode).placeholder}
              showAttach={isAdvisorMode(mode)}
              attachment={activeAttachment}
              onAttach={(file) => { setAttachment(file); setAttachmentError(''); }}
              onRemoveAttachment={() => setAttachment(null)}
              onAttachError={setAttachmentError}
              hint={isAdvisorMode(mode) ? 'Attach a CMDB export, inventory or config file' : null}
              autoFocus
            />
            <div className="composer-footnote">AI-generated content can be inaccurate. Please review answers and generated code before use.</div>
          </div>
        </div>
      </Box>

      {/* Editor pane for generated multi-file Terraform */}
      {editorOpen && <CodeEditorPane files={editorFiles} onClose={() => setEditorFiles(null)} />}
    </Box>
  );
};

export default ChatPage;
